<template>
    <div class="dropdown-container" @click="onDropDownClick">
      <div class="dropdown-text"> {{ showText }} </div>
      <img class="dropdown-icon" src="@/icons/dropdown.png">
    </div>
  </template>
<script>

export default {
  name: 'CommonDropDownView',
  props: {
    showText: {
      type: String,
      default: ''
    }
  },
  methods: {
    onDropDownClick() {
      this.$emit('onDropDownClick')
    }
  }
}
</script>
  <style lang="scss" scoped>

  .dropdown-container {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 16px;
    background-color: #F5F7FA;
    margin-top: 16px;
    border-radius: 8px;
    .dropdown-text {
        font-size: 14px;
        color:#2c2c2c;
    }
    .dropdown-icon{
        width: 20px;
        height: 20px;
    }
  }
  </style>
